import { useBaseMask } from './useBaseMask'
import { InputAttributes, NumericFormatProps } from './utils/types'
import { useNumericFormat } from './utils/useNumericFormat'

export function useNumericMask<BaseType = InputAttributes>(
  props: NumericFormatProps<BaseType>,
) {
  const numericFormatProps = useNumericFormat(props)
  return useBaseMask(numericFormatProps)
}
